import React, { useState,useEffect } from 'react'
import AppLayout from '../../../../layout/components/AppLayout'
import { useAlert } from '../../../../context/AlertContext';
import grievanceServices from '../grievanceServices';
import useSystemMasterList from '../../../../hooks/useSystemMasterList';
import grievanceStatsServices from '../grivanceStatsServices';
import GrievanceTabularList from '../components/GrievanceTabularList';
import { useParams } from 'react-router-dom';

function SearchGrievancePage() {

	const [masters,getMasterLabel] = useSystemMasterList(['grievance-type','grievance-status']);
	const {phone} = useParams();
	const {AppAlert} = useAlert();
	const [phoneInput,setPhoneInput] = useState(phone?phone:"");
	const[grievanceList,setGrievanceList] = useState(null);
	const [grievanceStats,setGrivanceStats] = useState(null);

	const handlePhoneInput = (e) => {
        let val = e.target.value;
        if(val.length <= 10) {
            setPhoneInput(val)
        }
    }

	const doSearch = () =>{
		if(phoneInput.length < 10){
			//AppAlert("Invalid Phone Number","error")
			return false
		}
		setGrievanceList(null);
		grievanceServices.getByPhone("91"+phoneInput).then(res=>{
			setGrievanceList(res.data);
		}).catch(()=>{
			AppAlert("Something Went wrong, Try Again")
		})
	}

	useEffect(()=>{
		doSearch();
	},[phoneInput])

	const getGrievanceStats = () =>{
        if(grievanceList && masters){
            let stats = grievanceStatsServices.generateStatsFromList(grievanceList,masters);
            setGrivanceStats(stats);
        }
    }

    useEffect(()=>{
        getGrievanceStats()
    },[grievanceList,masters])

  	return (
		<AppLayout>
			<div className='container'>
				<div className='row'>
					<div className="col-md-6">
						<div className="form-floating mb-3">
							<input type="number" className="form-control" placeholder="" 
								value={phoneInput}
								onChange={handlePhoneInput}
                                onKeyUp={ (e) =>{
									if(e.key === 'Enter') {
                                        e.preventDefault();
                                        doSearch();
                                    }
                                }}
							/>
							<label >Complainant Phone Number</label>
						</div>
					</div>
				</div>
			</div>
			<div>
			 	{grievanceStats &&
					<GrievanceTabularList grievanceList={grievanceList} getMasterLabel={getMasterLabel} grievanceStats={grievanceStats} />
				}
			</div>
		</AppLayout>
	)
}

export default SearchGrievancePage